module.exports = __webpack_public_path__ + "static/media/estrellaDamm.448f67c4.jpg";